import gql from "graphql-tag";
import { ProductFields } from "graphql-client-product/fragments/product-fields";
import { ProductFields as PDPFields } from "graphql-client-product/fragments/pdp-fields";
import { OptimizedBaseProductFields } from "graphql-client-product/fragments/base-product-fields";

export const queryProduct = gql`
  query Product(
    $productId: String!
    $fullSkuId: String
    $swatchID: String
    $categoryId: String
    $filter: String
    $userType: String
    $currencyCode: String
    $siteId: String
    $measureSystem: String
    $locale: String
    $postalCode: String
    $countryCode: String
    $newPdpLayout: Boolean
    $opensearch: Boolean
  ) {
    product(
      productId: $productId
      categoryId: $categoryId
      fullSkuId: $fullSkuId
      swatchID: $swatchID
      filter: $filter
      userType: $userType
      currencyCode: $currencyCode
      siteId: $siteId
      measureSystem: $measureSystem
      locale: $locale
      postalCode: $postalCode
      newPdpLayout: $newPdpLayout
      countryCode: $countryCode
      opensearch: $opensearch
    ) {
      __typename
      ...ProductFields
    }
  }
  ${ProductFields}
`;

export const queryProductOptimized = gql`
  query Product(
    $productId: String!
    $fullSkuId: String
    $swatchID: String
    $categoryId: String
    $filter: String
    $userType: String
    $currencyCode: String
    $siteId: String
    $measureSystem: String
    $locale: String
    $postalCode: String
    $countryCode: String
    $newPdpLayout: Boolean
    $opensearch: Boolean
  ) {
    product(
      productId: $productId
      categoryId: $categoryId
      fullSkuId: $fullSkuId
      swatchID: $swatchID
      filter: $filter
      userType: $userType
      currencyCode: $currencyCode
      siteId: $siteId
      measureSystem: $measureSystem
      locale: $locale
      postalCode: $postalCode
      newPdpLayout: $newPdpLayout
      countryCode: $countryCode
      opensearch: $opensearch
    ) {
      __typename
      ...BaseProductFields
    }
  }
  ${OptimizedBaseProductFields}
`;

const CoordinateFields = gql`
  fragment CoordinateFields on Coordinates {
    top
    left
    right
    bottom
  }
`;

export const queryPDP = gql`
  fragment CoordinateFields on Coordinates {
    top
    left
    right
    bottom
  }

  query Product(
    $productId: String!
    $fullSkuId: String
    $swatchID: String
    $categoryId: String
    $filter: String
    $userType: String
    $currencyCode: String
    $siteId: String
    $measureSystem: String
    $locale: String
    $postalCode: String
    $newPdpLayout: Boolean
    $screen: String
    $opensearch: Boolean
  ) {
    product(
      productId: $productId
      categoryId: $categoryId
      fullSkuId: $fullSkuId
      swatchID: $swatchID
      filter: $filter
      userType: $userType
      currencyCode: $currencyCode
      siteId: $siteId
      measureSystem: $measureSystem
      locale: $locale
      postalCode: $postalCode
      newPdpLayout: $newPdpLayout
      screen: $screen
      opensearch: $opensearch
    ) {
      imageCoordinates {
        xs {
          ...CoordinateFields
        }
        sm {
          ...CoordinateFields
        }
        md {
          ...CoordinateFields
        }
        gf {
          ...CoordinateFields
        }
        lg {
          ...CoordinateFields
        }
        xl {
          ...CoordinateFields
        }
      }
      ...ProductFields
      __typename
    }
  }
  ${PDPFields}
  ${CoordinateFields}
`;
